module.exports = "/images/sac-cordon.png?640b460a8abb683e00a7c89842f6516c";